import type { ReactNode } from 'react';
import { Modal } from './Modal';

/** Asks before something that cannot be undone. Cancel is the safe default: Escape and closing the dialog both cancel. */
export function ConfirmDialog({
  open,
  title,
  confirmLabel,
  onConfirm,
  onCancel,
  children,
}: {
  open: boolean;
  title: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  children: ReactNode;
}) {
  return (
    <Modal open={open} title={title} onClose={onCancel}>
      <div className="mb-3 text-sm">{children}</div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          autoFocus
          className="rounded border border-line px-3 py-1 text-sm hover:border-accent"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="rounded-md border border-down px-3 py-1 text-sm font-semibold text-down hover:bg-down/10"
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
